import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {
  AssetMetaInterface,
  ProjectAssetLink,
  AssetService,
} from '@taopix/taopix-core/dist/types/types';

export type ProjectLinkResponse = {
  assets: Partial<ProjectAssetLink>[];
};

export default class MetaDataCheckerService {
  constructor(
    private server: APIServer,
    private services: AssetService[],
    private groupCode: string
  ) {}

  public checkMeta = (assets: AssetMetaInterface[]): Promise<Partial<ProjectAssetLink>[]> => {
    const {server, services, groupCode} = this;
    if (!assets) {
      return Promise.resolve([]);
    }

    const response: Partial<ProjectAssetLink>[] = [];

    // we need to reduce down the asset list based on service code
    const sections = assets.reduce<Record<string, AssetMetaInterface[]>>((accumulator, current) => {
      if (
        '' !== current.externalId &&
        current?.link?.metaDataLastModified &&
        '' !== current?.link?.metaDataLastModified
      ) {
        // assets that have recently been added will not have any project link information
        if (null !== current?.link?.id) {
          if (!accumulator.hasOwnProperty(current.serviceCode)) {
            accumulator[current.serviceCode] = [];
          }
          accumulator[current.serviceCode].push(current);
        }
      }
      return accumulator;
    }, {});

    return new Promise((resolve, reject) => {
      const serviceCodes = Object.keys(sections);
      serviceCodes.forEach(serviceCode => {
        const service = services.find(s => s.code === serviceCode);
        if (!service) {
          return;
        }

        const map = sections[serviceCode].reduce((accumulator, current) => {
          if (!accumulator[current.externalId as string] && current.link.id > 0) {
            accumulator[current.externalId as string] = current.link.id;
          }
          return accumulator;
        }, {});

        server
          .post<ProjectLinkResponse>(
            `/api/assetservice/${service.id}/metadata`,
            {
              assets: map,
              groupCode,
            },
            {
              token: 'token',
              json: true,
            }
          )
          .then(({data}) => {
            response.concat(data.assets);
            if (serviceCodes.indexOf(serviceCode) + 1 === serviceCodes.length) {
              resolve(response);
            }
          })
          .catch(error => reject(error));
      });
    });
  };
}
